import { Fragment, type ReactNode } from "react";

const PHONE = /08-517 082 81/g;

/**
 * Our phone number in running text, as a real tel: link. Left as plain text,
 * iOS Safari wraps it in its own link before React hydrates, and the mismatch
 * throws a hydration error on every page that mentions it (Sentry
 * UNGDOMSKRAFT-WEB-3). A link of our own keeps the number tappable now that
 * format detection is off, and PhoneClickTracker counts the tap.
 */
export function withPhoneLinks(text: string): ReactNode {
  const parts = text.split(PHONE);
  if (parts.length === 1) return text;
  return parts.map((part, i) => (
    <Fragment key={i}>
      {part}
      {i < parts.length - 1 && (
        <a href="tel:+46851708281" className="font-medium text-brand-secondary hover:underline">
          08-517 082 81
        </a>
      )}
    </Fragment>
  ));
}
